import React from "react";
import { unstable_batchedUpdates } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLastSplittedStringItem } from "../../src/taskpane/components/helpers/stringHelper";
import { getTeamsChannelLocationParts } from "../../src/taskpane/components/helpers/teamsChannelLocationHelper";
import { RootState } from "../../src/taskpane/components/_v2/redux/storeMain";
import { resolveCopyMoveTrayState } from "./helpers/copyMoveTrayState";
import { IAllDocumentsViewOverride, getDirectoryContentKey, resolveAllDocumentsView } from "./helpers/directoryContentScope";
import { createDirectoryLoadTracker } from "./helpers/directoryLoadTracker";
import { useResetOnKeyChange } from "./hooks/useResetOnKeyChange";
import { CommandBar, ICommandBarItemProps, ICommandBarStyles, ConstrainMode, DetailsListLayoutMode, IColumn, IGroup, mergeStyleSets, ScrollablePane, ScrollbarVisibility, Selection, SelectionMode, ShimmeredDetailsList, TooltipHost, Icon, Label, Link, Dialog, DialogFooter, PrimaryButton, DialogType, IContextualMenuItem, Spinner, SpinnerSize, IIconProps, IDetailsListProps, DetailsHeader, Stack, FontIcon, IStackTokens, DetailsRow, ISpinnerStyles, } from "@fluentui/react";
import { ComponentTypes } from "../../src/taskpane/config/config";
import { IPageSettings } from "../../src/taskpane/interfaces/IPageSettings";
import { addWorkingDirectories, addWorkingDirectory, removeDirectoriesByIndexAndAddItem } from "../../src/taskpane/redux/modules/workingDirectory";
import { getItemCustomSelect, getTeamChannelInfo, getTeamChannelRelatedSitesInfo } from "../../src/taskpane/services/GraphService";
import authModule from "../../utilities/AuthModule";
import { LanguageContext } from "../../utilities/LocalizationModule";
import { getLocationDocumentLibraries, getLocationSharepointLists, getLocationSubSites, getLocationTeamChannels, getLocationTessProjectLibrariesAndFolders, getLocationTessProjects, ILocation, ISharepointFolderLocation, ISharepointListLocation, ITeamChannelLocation, ITessProjectLocation, LocationType } from "../Services/LocationService";
import { carryCollapsedGroups, composeLocationSections, ILocationSection, ILocationSectionInput, orderLocationSections } from "./locationSections";
import { gridSelectedItems } from "./ContentManagerBody";
import { addPinnedItem, isFolderPinned, removePinnedItem } from "../../src/taskpane/redux/modules/pinnedItems";
import { ITeamChannelDocumentLibrary } from "../../src/taskpane/interfaces/services/ITeamChannelDocumentLibrary";
import { FileTypeEnum } from "../../src/taskpane/components/enums/fileTypeEnum";
import { FolderTypeIconEnum } from "../../src/taskpane/components/enums/FolderTypeIconEnum";
import { IStoreItem } from "../../src/taskpane/interfaces/IStoredItem";
import { CMFAdvancedSearchPanel } from "../Panels/CMFAdvancedSearchPanel";
import { detailRowLinkStyles, menuItemIconStyles } from "../../src/taskpane/config/controlStyles";
import { setIsContentManagerContentLoading } from "../../src/taskpane/redux/modules/contentManagerDirectory";
import { documentLibraryItem, SiteItem } from "../../src/taskpane/redux/models/reduxModels";
import { CMPermissionsPanel } from "../Panels/CMPermissionsPanel";
import { logger } from "../../utilities/logger";
import { defaultFontColor } from "../../src/taskpane/styles/iconStyles";
import { FileIconType, getFileTypeIconProps } from "@fluentui/react-file-type-icons";
import { displayHeight, SharePointFolderContentTypeIds } from "../../src/taskpane/config/constants";
import { DraggableContainer } from "../../src/taskpane/components/_v2/components/Explorer/FolderView/DraggableContainer";
import generalModule from "../../utilities/GeneralModule";
import { ChannelShareIcon } from "../../src/taskpane/components/_v2/components/SvgIcons/ChannelShareIcon";
import { ChannelPrivateIcon } from "../../src/taskpane/components/_v2/components/SvgIcons/ChannelPrivateIcon";
import { getLists } from "../../src/taskpane/services/SharePointRestServices";
import { IListInfo } from "@pnp/sp/lists/types";
import { getTessProjectSite, TessProjectStatusEnum } from "../../src/taskpane/services/TessService";
import { IHit } from "../../src/taskpane/interfaces/IGraphSearchQueryResult";
import { tryGetSiteRelativeUrl } from "../../src/taskpane/components/helpers/UrlHelper";
import { tryDecodeUriComponent } from "../../utilities/EncodeDecode";
import { CancellableSharePointRestApi } from "../../src/taskpane/services/CancellableSharePointRestApi";
import { BrandIcons } from "../../src/taskpane/config/brandIcons";
import { OpenFolder20Regular } from "../../src/taskpane/components/_v2/components/SvgIcons/OpenFolder20Regular";
import { PinOff20Regular } from "../../src/taskpane/components/_v2/components/SvgIcons/PinOff20Regular";
import { Pin20Regular } from "../../src/taskpane/components/_v2/components/SvgIcons/Pin20Regular";
import { Key20Regular } from "../../src/taskpane/components/_v2/components/SvgIcons/Key20Regular";
import { ArrowClockwise20Regular } from "../../src/taskpane/components/_v2/components/SvgIcons/ArrowClockwise20Regular";
import { SquareMultiple20Regular } from "../../src/taskpane/components/_v2/components/SvgIcons/SquareMultiple20Regular";
import { Channel20Regular } from "../../src/taskpane/components/_v2/components/SvgIcons/Channel20Regular";
import { FolderDocument20Regular } from "../../src/taskpane/components/_v2/components/SvgIcons/FolderDocument20Regular";
import { List20Regular } from "../../src/taskpane/components/_v2/components/SvgIcons/List20Regular";
import { PauseCircle20Regular } from "../../src/taskpane/components/_v2/components/SvgIcons/PauseCircle20Regular";
import { SharePointSiteHelper } from "../../utilities/SharePointSiteHelper";
import { IClientGroupView, resolveClientGroupView } from "../../src/taskpane/services/clientGroupService";
import { IClientGroupSearchSite } from "../../src/taskpane/components/helpers/sharepointSearch/clientGroupSearchScope";
import { buildGroupLibraryDirectories } from "./helpers/groupLibraryNavigation";
import { buildClientGroupGridSections, hasClientGroupSections, IClientGroupGridSections, NO_CLIENT_GROUP_SECTIONS } from "./clientGroupGridSections";
import { IObservedPromise, observeSettled } from "../../utilities/observeSettled";
import { CacheHelper } from "../../utilities/CacheHelper";
import { ContentBodyAllDocuments } from "./ContentBodyAllDocuments";
import { renderCollapsibleGroupHeader } from "./helpers/collapsibleGroupHeader";

const classNames = mergeStyleSets({
    wrapper: {
        height: displayHeight,
        position: "relative",
    },
    svgIcon: {
        fontSize: 18,
        color: defaultFontColor
    }
});

// const openInBrowserIconProps: IIconProps = { iconName: "SharepointLogo" };
// const unpinIconProps: IIconProps = { iconName: "Unpin" };
// const pinIconProps: IIconProps = { iconName: "Pin" };
// const advancedSearchIconProps: IIconProps = { iconName: "SearchData" };
// const refreshIconProps: IIconProps = { iconName: "Refresh" };
// const permissionsIconProps: IIconProps = { iconName: "Permissions" };

const commandBarStyle: Partial<ICommandBarStyles> = {
    root: {
        borderTop: '1px solid var(--db-border, rgb(237, 235, 233))',
        borderBottom: '1px solid var(--db-border, rgb(237, 235, 233))',
        paddingLeft: 0,
        paddingRight: 10,
        paddingBottom: 3,
        paddingTop: 3
    }
};

const gridLinkStackTokens: IStackTokens = {
    childrenGap: 5
};

const rootLevelItemsSpinnerStyles: ISpinnerStyles = {
    root: {
        alignItems: "flex-start"
    }
}

function _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
    const key = columnKey as keyof T;
    return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
};

// Matches a location row against the global inactive-client set. Site rows (hubs/subsites) match on
// their web url/id; Tess project rows match on their dossier site url (when present synchronously).
const isLocationInactive = (item: ILocation): boolean => {
    if (!item) {
        return false;
    }
    switch (item.type) {
        case LocationType.HubSite:
        case LocationType.Site:
            return SharePointSiteHelper.isSiteInactive(item.webUrl, item.id);
        case LocationType.TessProject:
            const dossiers = (item as ITessProjectLocation).dossierMetadata;
            return Array.isArray(dossiers) && dossiers.some(dossier => SharePointSiteHelper.isSiteInactive(dossier?.siteUrl, undefined));
        default:
            return false;
    }
};

const _getKey = (item: any, index?: number): string => {
    return item?.key;
};

interface IContentBodyLibrariesProps {
}

export const ContentBodyLibraries: React.FunctionComponent<IContentBodyLibrariesProps> = ({

}: IContentBodyLibrariesProps) => {
    const languageStrings = React.useContext(LanguageContext);

    const dispatch = useDispatch();

    const workingDirectories = useSelector((state: RootState) => state.workingDirectories.workingDirectories);
    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
    const siteInfo = useSelector((state: RootState) => state.tenantInfo.sites);
    const allowedSites = useSelector((state: RootState) => state.tenantInfo?.allowedSiteCollections);
    const clientListUrl = useSelector((state: RootState) => state.tenantInfo?.clientListUrl);
    const loadedSites = useSelector((state: RootState) => state.sharePointInfo?.sites);
    const tenantEnablePermissionManagement = useSelector((state: RootState) => state.tenantInfo?.enablePermissionManagement);
    const hideDocumentLibrariesInTeams = useSelector((state: RootState) => state.tenantInfo?.hideDocumentLibrariesInTeams);
    const allowOpenInSharePoint = useSelector((state: RootState) => (state.user.tenantAllowOpenInSharePoint ?? true) && !state.workingDirectories.workingDirectories?.some(dir => dir?.type === ComponentTypes.Docubird));
    const pinnedItems = useSelector((state: RootState) => state.pinned?.pinnedItems);
    const isTessEnabled = useSelector((state: RootState) => state.tenantInfo?.isTessEnabled);

    const [refresh, setRefresh] = React.useState<boolean>(false);
    // Set by the user's Refresh of this view, taken by the next load: that load reads the client
    // group membership afresh instead of from the session copy. (All documents' Refresh re-reads the
    // membership alone: refreshClientGroupMembership.)
    const forceClientGroupRefreshRef = React.useRef<boolean>(false);
    const refreshWithClientGroups = React.useCallback((): void => {
        forceClientGroupRefreshRef.current = true;
        setRefresh(currentValue => !currentValue);
    }, []);
    // The latest load's token: All documents' membership refresh applies its answer only while
    // that load is still the current one (no newer load, no unmount).
    const lastLoadTokenRef = React.useRef<number>(0);
    const membershipRefreshRef = React.useRef<number>(0);
    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [isUploadingFiles, setIsUploadingFiles] = React.useState<boolean>(false);
    const [isTeamChannelInfoLoading, setIsTeamChannelInfoLoading] = React.useState<boolean>(false);

    const [commandItems, setCommandItems] = React.useState<ICommandBarItemProps[]>();
    const [commandFarItems, setCommandFarItems] = React.useState<ICommandBarItemProps[]>();
    const [columns, setColumns] = React.useState<IColumn[]>(null);
    const [groups, setGroups] = React.useState<IGroup[]>(null);

    const [hubAssociatedHubs, setHubAssociatedHubs] = React.useState<ILocation[]>([]);
    const [hubAssociatedSites, setHubAssociatedSites] = React.useState<ILocation[]>([]);
    const [clientGroupMembers, setClientGroupMembers] = React.useState<ILocation[]>([]);
    // One section per client group the current site belongs to (the group's site first, then the other members).
    const [clientGroupParents, setClientGroupParents] = React.useState<ILocationSection<ILocation>[]>([]);
    // Every client-group site of this one (the set Advanced Search and the top-bar search use),
    // for the All documents view - including members listed elsewhere as hub children or subsites.
    const [clientGroupAggregateSites, setClientGroupAggregateSites] = React.useState<IClientGroupSearchSite[]>([]);
    // The site's client group lookup is still out although the rest has loaded: the All documents
    // view holds its first paint for it.
    const [isResolvingClientGroups, setIsResolvingClientGroups] = React.useState<boolean>(false);
    // Bumped when a late client group answer changes the sections; the grid then recomposes.
    const [lateClientGroupRevision, setLateClientGroupRevision] = React.useState<number>(0);
    // The client group sections on screen: a refresh keeps them until its own lookup answers.
    const clientGroupSectionsRef = React.useRef<IClientGroupGridSections>(NO_CLIENT_GROUP_SECTIONS);
    // The column sort the user chose since the load: late client group sections are sorted the same way.
    const userSortRef = React.useRef<{ fieldName: string; isSortedDescending: boolean } | null>(null);
    // Bumped by every column sort. The grid's setKey changes with it, and with each load, so both
    // reset the row selection as before; late client group sections keep it.
    const [sortRevision, setSortRevision] = React.useState<number>(0);
    const [subSites, setSubSites] = React.useState<ILocation[]>([]);
    const [channels, setChannels] = React.useState<ILocation[]>([]);
    const [documentLibraries, setDocumentLibraries] = React.useState<ILocation[]>([]);
    const [sharepointLists, setSharepointLists] = React.useState<ILocation[]>([]);
    const [tessActiveProjectSites, setTessActiveProjectSites] = React.useState<ITessProjectLocation[]>([]);
    const [tessDraftProjectSites, setTessDraftProjectSites] = React.useState<ITessProjectLocation[]>([]);
    const [tessFinishedProjectSites, setTessFinishedProjectSites] = React.useState<ITessProjectLocation[]>([]);
    const [tessProjectFolders, setTessProjectFolders] = React.useState<ILocation[]>([]);

    const [items, setItems] = React.useState<(ILocation | null)[] | undefined>(undefined);
    const [selectedLocation, setSelectedLocation] = React.useState<ILocation>();
    const [selectedItems, setSelectedItems] = React.useState<gridSelectedItems>({ items: [], count: 0 });
    const [selectedSharepointListId, setSelectedSharepointListId] = React.useState<string>();

    const [isAdvancedSearchPanelOpen, setIsAdvancedSearchPanelOpen] = React.useState<boolean>(false);
    const [isPermissionsPanelOpen, setIsPermissionsPanelOpen] = React.useState<boolean>(false);

    // Session toggle of the aggregate view, tagged with the scope it was made for; the
    // persisted preference decides everywhere else (see resolveAllDocumentsView).
    const [allDocumentsViewOverride, setAllDocumentsViewOverride] = React.useState<IAllDocumentsViewOverride | null>(null);

    // While a copy/move is waiting for a destination, show the locations list: the
    // aggregate grid cannot be used to pick one. Derived from redux rather than held as
    // local state so it survives this component unmounting while the user is inside a
    // library, and so it lifts by itself the moment the operation completes or is
    // cancelled — returning the user to whichever view they actually prefer.
    //
    // The previous approach routed this through toggleAllDocumentsView(false), which
    // persists to local storage: a single copy/move turned the aggregate view off for
    // that site permanently.
    // Primitives, not the whole moveTo object: during a copy job it is replaced on every
    // progress tick, which would re-render this large component for nothing.
    const copyMoveEnabled = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.moveToEnabled);
    const copyMoveMode = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.mode);
    const isPickingCopyMoveDestination = React.useMemo(
        () => resolveCopyMoveTrayState({ moveTo: { moveToEnabled: copyMoveEnabled, mode: copyMoveMode } }).visible,
        [copyMoveEnabled, copyMoveMode]
    );

    // THE Tess predicate. Component-scoped and read by every site that needs it (the
    // "Top level items" column, the locations load, the view-switcher, the deferred
    // root-count trigger, the render branch) so those cannot drift apart — they were
    // three independent copies of this expression before.
    const isTessLocation: boolean = isTessEnabled
        && (currentDirectory?.type === ComponentTypes.TessAccount || currentDirectory?.type === ComponentTypes.TessProject);

    // Whether this directory has anything to load — the load effect's entry condition,
    // kept as ONE expression so the reset below and the load cannot drift apart.
    const canLoadDirectory: boolean = !!currentDirectory?.siteId
        || (isTessLocation && currentDirectory?.type === ComponentTypes.TessProject);

    // Loaded content is scoped to the directory it was loaded for and dropped IN THE
    // SAME RENDER the directory changes. The load only replaces it once its fetches
    // resolve, and this component stays mounted across site changes (ContentManagerBody
    // keys nothing on the site) — so until this reset, one render paired the previous
    // site's libraries with the new site's URL, and both the aggregate grid and the
    // root-item-count fan-out fetched the old list ids on the new web (a 404 per
    // library; Tess sources, which carry their own site URL, showed the wrong project's
    // documents instead). Render-time rather than an effect because children mounted in
    // that one render start their fetches before any parent effect runs. A refresh keeps
    // the key, so it keeps its rows under the shimmer.
    const directoryContentKey = getDirectoryContentKey(currentDirectory);
    useResetOnKeyChange(directoryContentKey, () => {
        setHubAssociatedHubs([]);
        setHubAssociatedSites([]);
        setClientGroupMembers([]);
        setClientGroupParents([]);
        setClientGroupAggregateSites([]);
        setIsResolvingClientGroups(false);
        clientGroupSectionsRef.current = NO_CLIENT_GROUP_SECTIONS;
        setSubSites([]);
        setChannels([]);
        setDocumentLibraries([]);
        setSharepointLists([]);
        setTessActiveProjectSites([]);
        setTessDraftProjectSites([]);
        setTessFinishedProjectSites([]);
        setTessProjectFolders([]);
        setItems(undefined);
        setGroups(null);
        // Shimmer from the first render when a load is coming, rather than one frame of
        // an empty grid; a directory with nothing to load must not shimmer forever.
        setIsLoading(canLoadDirectory);
    });

    // Identity of the aggregate view's persisted state (toggle, hidden columns). Plain
    // sites keep the bare siteId — existing persisted keys must keep resolving. Tess
    // directories inherit siteId from their nearest ancestor, so the Tess ids are folded
    // in: without them, toggling the view on the parent site would toggle it for every
    // Tess account and project underneath (and vice versa). A Tess directory WITHOUT a
    // tessAccountId gets no scope at all (undefined disables the toggle and the view) —
    // a `siteId||` key would otherwise be shared by every such degenerate directory.
    const allDocumentsScopeId: string | undefined = isTessLocation
        ? (currentDirectory?.tessAccountId
            ? `${currentDirectory?.siteId ?? ""}|${currentDirectory.tessAccountId}|${currentDirectory?.tessProjectId ?? ""}`
            : undefined)
        : currentDirectory?.siteId;

    // The all-documents toggle is per scope and survives navigation/restarts. Derived
    // DURING RENDER, not in an effect: the effect-based read committed one render with
    // the previous scope's view under the new scope, which mounted the aggregate grid
    // (and its fetches) for a directory that shows the locations list, or vice versa.
    const persistedAllDocumentsPreference = React.useMemo(
        () => allDocumentsScopeId ? CacheHelper.get(`allDocumentsView.${allDocumentsScopeId}`, true) === true : false,
        [allDocumentsScopeId]
    );
    const isAllDocumentsView = resolveAllDocumentsView(allDocumentsScopeId, persistedAllDocumentsPreference, allDocumentsViewOverride);

    const toggleAllDocumentsView = React.useCallback((value: boolean) => {
        setAllDocumentsViewOverride({ scopeId: allDocumentsScopeId, value });
        if (allDocumentsScopeId) {
            CacheHelper.set(`allDocumentsView.${allDocumentsScopeId}`, value, true);
        }
    }, [allDocumentsScopeId]);

    // A Tess directory aggregates the SharePoint targets of its dossiers: the library-
    // shaped ones land in `documentLibraries`, the folder-shaped ones in
    // `tessProjectFolders` (disjoint sets — getTessDossierData keys them on itemId).
    // An account whose listing is only project groups has nothing to aggregate.
    const hasTessAggregatableSources: boolean =
        (documentLibraries?.length ?? 0) > 0 || (tessProjectFolders?.length ?? 0) > 0;

    // THE condition for "the locations list is what's on screen". Shared with the render
    // branch at the bottom so the two cannot disagree — note that selecting the aggregate
    // view no longer implies the locations list is hidden, because an armed copy/move
    // forces it back.
    //
    // Tess joins the aggregate view through its dossier sources; the locations list
    // reasserts itself only when a LOADED Tess directory turns out to have none (project
    // groups would otherwise hide behind an empty grid). While loading, the toggle is
    // honoured so the view doesn't flash locations→grid on every Tess navigation.
    const isLocationsListVisible = !isAllDocumentsView
        || isPickingCopyMoveDestination
        || (isTessLocation && !isLoading && !hasTessAggregatableSources);

    // Read inside the locations load, which is a long async run: by the time it reaches
    // the root-count step the user may have switched views, and the render-scope value
    // captured when it started would be stale.
    const isLocationsListVisibleRef = React.useRef<boolean>(isLocationsListVisible);
    isLocationsListVisibleRef.current = isLocationsListVisible;

    const cancellableSharePointRestApiService = React.useRef<CancellableSharePointRestApi>();
    // Generation of the directory load (see directoryLoadTracker): results of a
    // superseded load are dropped, and the root-item-count claim is per generation.
    const loadTrackerRef = React.useRef(createDirectoryLoadTracker());

    const _selection = React.useRef(new Selection({
        onSelectionChanged: () => _getSelectionDetails()
    }));

    const _getSelectionDetails = () => {
        setSelectedItems({ items: _selection.current.getSelection(), count: _selection.current.getSelectedCount() });
    };

    const [isChannelErrorDialogHidden, setIsChannelErrorDialogHidden] = React.useState(true);

    const hideChannelErrorDialog = () => {
        setIsChannelErrorDialogHidden(true);
    }
    const showChannelErrorDialog = () => {
        setIsChannelErrorDialogHidden(false);
    }

    React.useEffect(() => {
        const columns: IColumn[] = [
            {
                key: 'locationIcon',
                name: 'Icon',
                isIconOnly: true,
                minWidth: 20,
                maxWidth: 20,
                onRender: (item: ILocation) => getLocationImage(item),
            },
            {
                key: 'locationName',
                name: languageStrings.Name,
                fieldName: 'displayName',
                minWidth: 250,
                maxWidth: 350,
                isRowHeader: true,
                isResizable: true,
                isSorted: true,
                isSortedDescending: false,
                sortAscendingAriaLabel: 'Sorted A to Z',
                sortDescendingAriaLabel: 'Sorted Z to A',
                data: 'string',
                onRender: (item: ILocation) => (
                    <TooltipHost content={item.description?.length > 0 ? item.description : null}>
                        {
                            getLocationLink(item)
                        }
                    </TooltipHost>
                ),
                isPadded: true,
            }
        ];

        const loadListsAndLibraries: boolean = !currentDirectory?.isSharedTeam && (!hideDocumentLibrariesInTeams || !currentDirectory?.teamGroupId);
        if (loadListsAndLibraries) {
            if (!isTessLocation) {
                columns.push(
                    {
                        key: 'locationRootItemCount',
                        name: languageStrings.TopLevelItems,
                        fieldName: 'rootItemCount',
                        minWidth: 80,
                        maxWidth: 80,
                        isResizable: true,
                        data: 'number',
                        onRender: (item: ILocation) => {
                            const listLocation: ISharepointListLocation = item as ISharepointListLocation;
                            if (listLocation?.rootItemCount !== undefined) {
                                return <span>{listLocation.rootItemCount}</span>;
                            }

                            if (listLocation.type === LocationType.DocumentLibrary && listLocation.isCalculatingRootItemCount) {
                                return <Spinner styles={rootLevelItemsSpinnerStyles} size={SpinnerSize.small} />;
                            }

                            return null;
                        },
                        isPadded: true,
                    }
                );
            }

            columns.push(
                {
                    key: 'locationItemCount',
                    name: languageStrings.Items,
                    fieldName: 'itemCount',
                    minWidth: 50,
                    maxWidth: 50,
                    isResizable: true,
                    data: 'number',
                    onRender: (item: ILocation) => {
                        const listLocation: ISharepointListLocation = item as ISharepointListLocation;
                        if (listLocation?.itemCount !== undefined) {
                            return <span>{listLocation.itemCount}</span>;
                        }
                        else {
                            return null;
                        }
                    },
                    isPadded: true,
                }
            );
        }

        columns.push(
            {
                key: 'locationType',
                name: "Type",
                fieldName: 'type',
                minWidth: 200,
                maxWidth: 200,
                isResizable: true,
                sortAscendingAriaLabel: 'Sorted A to Z',
                sortDescendingAriaLabel: 'Sorted Z to A',
                data: 'string',
                onRender: (item: ILocation) => getLocationTypeText(item),
                isPadded: true,
            },
            {
                key: 'locationCreated',
                name: languageStrings.Created,
                fieldName: 'createdDateTimeValue',
                minWidth: 70,
                maxWidth: 90,
                isResizable: true,
                data: 'number',
                onRender: (item: ILocation) => {
                    return <span>{item.createdDateTime}</span>;
                },
                isPadded: true,
            },
            {
                key: 'locaionModified',
                name: languageStrings.Modified,
                fieldName: 'lastModifiedDateTimeValue',
                minWidth: 70,
                isResizable: true,
                data: 'number',
                onRender: (item: ILocation) => {
                    return <span>{item.lastModifiedDateTime}</span>;
                },
                isPadded: true,
            }
        );

        setColumns(columns);
        userSortRef.current = null;

        // The Tess arm carries isTessLocation for the same reason as the fetches below: a
        // siteId-less Tess project with Tess switched off has nothing left to load, and
        // running the load anyway only fires site requests with an undefined siteId. A Tess
        // directory that DOES inherit a siteId still loads, as an ordinary site.
        if (canLoadDirectory) {

            if (currentDirectory?.webUrl) {
                cancellableSharePointRestApiService.current = new CancellableSharePointRestApi(currentDirectory.webUrl);
            }

            // One generation per load. Re-arms the once-per-load root-count claim (a fresh
            // locations array has fresh, undefined counts) and lets the results below be
            // dropped when a newer load has started: this run cannot be cancelled, and an
            // older site's results landing under a newer directory did not self-heal.
            const loadToken = loadTrackerRef.current.begin();
            lastLoadTokenRef.current = loadToken;
            const isSuperseded = (): boolean => !loadTrackerRef.current.isCurrent(loadToken);
            const forceRefreshClientGroups: boolean = forceClientGroupRefreshRef.current;
            forceClientGroupRefreshRef.current = false;

            (async () => {
                setIsLoading(true);

                try {
                    const graphAccessToken = await authModule.getGraphAccessToken();
                    // Client-group members and groups (accountancy tenants): never rejects, and runs
                    // alongside the fan-out below without holding it up. Each gets its own section
                    // below the libraries, in the first render when it has answered by then and
                    // joining the grid when it answers later.
                    const clientGroupLookup: IObservedPromise<IClientGroupView> | undefined = !currentDirectory.isSharedTeam && !isTessLocation && clientListUrl?.trim()
                        ? observeSettled(resolveClientGroupView({ clientListUrl, compositeSiteId: currentDirectory.siteId, loadedSites, allowedSites, forceRefresh: forceRefreshClientGroups }))
                        : undefined;
                    let [hubSites, subSites, channels, documentLibraries, sharepointLists, allListCount, tessAccountContent, tessProjectLibsAndFolders] = await Promise.all([
                        currentDirectory.isHub && !isTessLocation ? getLocationSubSites(graphAccessToken, currentDirectory.hubId, allowedSites, true) : [],
                        !currentDirectory.isSharedTeam && !isTessLocation ? getLocationSubSites(graphAccessToken, currentDirectory.siteId, allowedSites) : [],
                        !isTessLocation ? getLocationTeamChannels(graphAccessToken, currentDirectory.teamGroupId) : [],
                        !currentDirectory.isSharedTeam && (!hideDocumentLibrariesInTeams || !currentDirectory.teamGroupId) && !isTessLocation ? getLocationDocumentLibraries(graphAccessToken, currentDirectory.siteId) : [],
                        !currentDirectory.isSharedTeam && (!hideDocumentLibrariesInTeams || !currentDirectory.teamGroupId) && !isTessLocation ? getLocationSharepointLists(graphAccessToken, currentDirectory.siteId) : [],
                        !currentDirectory.isSharedTeam && !isTessLocation ? getLists(await authModule.getSharePointAccessToken(), currentDirectory.webUrl) : [],
                        // isTessLocation, not the type alone: with Tess switched off at the
                        // tenant these fetches used to run anyway while every OTHER branch
                        // here treated the directory as an ordinary site. The two sets then
                        // merged, and the root-count fan-out — which only runs when
                        // !isTessLocation — counted the Tess libraries, whose lists live on
                        // OTHER webs, against this directory's webUrl. Tess disabled now
                        // means no Tess content, and the predicate decides it everywhere.
                        isTessLocation && currentDirectory.type === ComponentTypes.TessAccount && currentDirectory.tessAccountId ? getLocationTessProjects(graphAccessToken, currentDirectory.tessAccountId) : null,
                        isTessLocation && currentDirectory.type === ComponentTypes.TessProject && currentDirectory.tessAccountId && currentDirectory.tessProjectId ? getLocationTessProjectLibrariesAndFolders(graphAccessToken, currentDirectory.tessAccountId, currentDirectory.tessProjectId) : null
                    ]);

                    // The bulk of the wait is behind us: a superseded load stops here rather
                    // than spending the Tess list-count and channel-info requests below.
                    if (isSuperseded()) {
                        return;
                    }

                    if (isTessLocation && (tessAccountContent?.libraries?.length > 0 || tessProjectLibsAndFolders?.libraries?.length > 0)) {
                        allListCount = await getLists(await authModule.getSharePointAccessToken(), tessAccountContent?.libraries?.length > 0 ? tessAccountContent.libraries[0].siteUrl : tessProjectLibsAndFolders.libraries[0].siteUrl);
                    }

                    const hubAssociatedHubs = hubSites?.filter(site => site.isHub);
                    const hubAssociatedSites = hubSites?.filter(site => !site.isHub);

                    if (channels?.length > 0) {
                        // Cache Private/Shared channel drive info
                        if (currentDirectory?.teamGroupId && currentDirectory?.teamDriveId) {
                            getTeamChannelRelatedSitesInfo(currentDirectory.teamGroupId, currentDirectory.teamDriveId, channels);
                        }
                    }
                    const folders = tessAccountContent?.folders ?? tessProjectLibsAndFolders?.folders ?? [];

                    documentLibraries = documentLibraries
                        .concat(tessAccountContent?.libraries ?? [])
                        .concat(tessProjectLibsAndFolders?.libraries ?? []);
                    if (documentLibraries?.length > 0) {
                        const sites: SiteItem[] = siteInfo?.filter(site => site.displayName?.trim().toLowerCase() === currentDirectory?.siteDisplayName?.trim().toLowerCase());
                        const hiddenDocumentLibraries: documentLibraryItem[] = sites?.length > 0 ? sites[0]?.documentLibraries?.filter(docLib => docLib.hidden === true) : [];
                        documentLibraries = documentLibraries.filter(docLib => !hiddenDocumentLibraries.some(hiddenLib => hiddenLib?.title?.trim().toLowerCase() === docLib?.displayName?.trim().toLowerCase()));
                        setSharepointListLocationItemCount(allListCount, documentLibraries);
                    }

                    let activeProjects: ITessProjectLocation[] = [];
                    let draftProjects: ITessProjectLocation[] = [];
                    let finishedProjects: ITessProjectLocation[] = [];
                    if (tessAccountContent?.projects?.length > 0) {
                        activeProjects = tessAccountContent.projects.filter(p => p.status === TessProjectStatusEnum.Active);
                        draftProjects = tessAccountContent.projects.filter(p => p.status === TessProjectStatusEnum.Draft);
                        finishedProjects = tessAccountContent.projects.filter(p => p.status === TessProjectStatusEnum.Finished);
                    }

                    if (sharepointLists?.length > 0) {
                        setSharepointListLocationItemCount(allListCount, sharepointLists, true);
                    }

                    // The client group sections, when the lookup has answered by now. Otherwise the ones on
                    // screen stay until it does: none for a new site, the current ones on a refresh.
                    // Members already listed as hub children or real subsites stay where they are.
                    const listedSites: ILocation[] = [...(hubSites ?? []), ...(subSites ?? [])];
                    const clientGroupAnswer: { value: IClientGroupView } | undefined = clientGroupLookup?.settled();
                    const clientGroupSections: IClientGroupGridSections = clientGroupAnswer
                        ? buildClientGroupGridSections(clientGroupAnswer.value, listedSites, currentDirectory.siteId)
                        : clientGroupLookup ? clientGroupSectionsRef.current : NO_CLIENT_GROUP_SECTIONS;

                    // One ordered section list decides the groups and the row order (locationSections.ts),
                    // shared with the column sort below so the two cannot drift apart.
                    const { groups, items: orderedItems } = composeLocationSections(orderLocationSections<ILocation>({
                        hubAssociatedHubs,
                        hubAssociatedSites,
                        subSites,
                        channels,
                        tessProjectFolders: folders,
                        documentLibraries,
                        clientGroupSites: clientGroupSections.memberRows,
                        clientGroups: clientGroupSections.parentSections,
                        tessActiveProjects: activeProjects,
                        tessDraftProjects: draftProjects,
                        tessFinishedProjects: finishedProjects,
                        sharepointLists
                    }, languageStrings));

                    // Every await is behind us (the Tess list count above included): a newer
                    // load owns the state and the loading flag from here on, so this one
                    // publishes nothing. Kept as the invariant guard even though the code
                    // between here and the check above is synchronous today.
                    if (isSuperseded()) {
                        return;
                    }

                    // Batched: a promise continuation is outside React's event batching,
                    // so each setter would otherwise commit its own render — and the
                    // aggregate grid would see the libraries one render before the rest.
                    clientGroupSectionsRef.current = clientGroupSections;
                    unstable_batchedUpdates(() => {
                        setHubAssociatedHubs(hubAssociatedHubs);
                        setHubAssociatedSites(hubAssociatedSites);
                        setClientGroupMembers(clientGroupSections.memberRows);
                        setClientGroupParents(clientGroupSections.parentSections);
                        // The All documents view reads every group site's libraries (members listed
                        // elsewhere too): the same set, in the same order, as Advanced Search.
                        setClientGroupAggregateSites(clientGroupSections.aggregateSites);
                        setIsResolvingClientGroups(!!clientGroupLookup && !clientGroupAnswer);
                        setSubSites(subSites);
                        setChannels(channels);

                        setDocumentLibraries(documentLibraries);
                        // Skipped when the aggregate grid is what will render: this fan-out
                        // pages each library 5000 IDs at a time to count its ROOT items, and
                        // the only thing that consumes the result is the locations list's
                        // "Top level items" column. The deferred effect below picks it up if
                        // the user switches to the locations list later.
                        if (!isTessLocation && documentLibraries?.length > 0 && currentDirectory?.webUrl
                            && isLocationsListVisibleRef.current) {
                            ensureRootItemCounts(currentDirectory.webUrl, documentLibraries);
                        }

                        setSharepointLists(sharepointLists);
                        setTessActiveProjectSites(activeProjects);
                        setTessDraftProjectSites(draftProjects);
                        setTessFinishedProjectSites(finishedProjects);
                        setTessProjectFolders(folders);

                        setItems(orderedItems);
                        setGroups(groups);
                    });

                    if (clientGroupLookup && !clientGroupAnswer) {
                        clientGroupLookup.promise.then(clientGroupView => {
                            if (isSuperseded()) {
                                return;
                            }
                            const lateSections: IClientGroupGridSections = buildClientGroupGridSections(clientGroupView, listedSites, currentDirectory.siteId);
                            // Most sites belong to no group: nothing was shown and nothing is to be.
                            if (!hasClientGroupSections(lateSections) && !hasClientGroupSections(clientGroupSectionsRef.current)) {
                                setIsResolvingClientGroups(false);
                                return;
                            }
                            clientGroupSectionsRef.current = lateSections;
                            // The grid recomposes from these in the effect below, against the rows as
                            // they stand by then.
                            unstable_batchedUpdates(() => {
                                setClientGroupMembers(lateSections.memberRows);
                                setClientGroupParents(lateSections.parentSections);
                                setClientGroupAggregateSites(lateSections.aggregateSites);
                                setIsResolvingClientGroups(false);
                                setLateClientGroupRevision(revision => revision + 1);
                            });
                        }, () => undefined);
                    }
                } catch (error) {
                    logger(error, "ContentBodyLibraries.tsx (LoadSiteContent)");
                }

                if (!isSuperseded()) {
                    setIsLoading(false);
                }
            })();
        }

        return () => {
            // Supersedes this load (re-run or unmount) before the next one begins.
            loadTrackerRef.current.invalidate();
            if (currentDirectory?.webUrl) {
                cancellableSharePointRestApiService.current.cancel(currentDirectory.webUrl);
            }
        };
        // isTessEnabled joins the keys because the load now BRANCHES on it (through
        // isTessLocation): a tenant flag that resolves after a Tess directory has already
        // loaded would otherwise leave that directory permanently without its Tess content,
        // since nothing else here would change. It is a session-stable boolean, so this
        // costs one extra load only in that race.
        // tessAccountId joins them because the content reset above keys on it: two Tess
        // accounts under one site share the inherited siteId and have no project id, so
        // without it the switch would reset the content and never load the new account's.
    }, [currentDirectory?.siteId, currentDirectory?.tessAccountId, currentDirectory?.tessProjectId, refresh, isTessEnabled]);

    // All documents' Refresh: the client group membership read afresh and applied the way a late
    // lookup answer is, without reloading the rest of the site (the view re-reads its own rows and
    // the group sites' libraries). Nothing at all where the site has no client group lookup.
    const refreshClientGroupMembership = React.useCallback((): void => {
        if (currentDirectory?.isSharedTeam || isTessLocation || !clientListUrl?.trim() || !currentDirectory?.siteId) {
            return;
        }
        const loadToken: number = lastLoadTokenRef.current;
        const refreshToken: number = ++membershipRefreshRef.current;
        const isCurrent = (): boolean => loadTrackerRef.current.isCurrent(loadToken) && refreshToken === membershipRefreshRef.current;
        const siteId: string = currentDirectory.siteId;
        const listedSites: ILocation[] = [...(hubAssociatedHubs ?? []), ...(hubAssociatedSites ?? []), ...(subSites ?? [])];
        setIsResolvingClientGroups(true);
        resolveClientGroupView({ clientListUrl, compositeSiteId: siteId, loadedSites, allowedSites, forceRefresh: true }).then(view => {
            if (!isCurrent()) {
                return;
            }
            const sections: IClientGroupGridSections = buildClientGroupGridSections(view, listedSites, siteId);
            if (!hasClientGroupSections(sections) && !hasClientGroupSections(clientGroupSectionsRef.current)) {
                setIsResolvingClientGroups(false);
                return;
            }
            clientGroupSectionsRef.current = sections;
            unstable_batchedUpdates(() => {
                setClientGroupMembers(sections.memberRows);
                setClientGroupParents(sections.parentSections);
                setClientGroupAggregateSites(sections.aggregateSites);
                setIsResolvingClientGroups(false);
                setLateClientGroupRevision(revision => revision + 1);
            });
        }, () => {
            if (isCurrent()) {
                setIsResolvingClientGroups(false);
            }
        });
    }, [currentDirectory?.isSharedTeam, currentDirectory?.siteId, isTessLocation, clientListUrl, loadedSites, allowedSites, hubAssociatedHubs, hubAssociatedSites, subSites]);

    React.useEffect(() => {
        (async () => {
            if (selectedItems?.count === 1) {
                let isLocationPinned: boolean = false;
                const selectedItem: ILocation = selectedItems.items[0];

                switch (selectedItem.type) {
                    case LocationType.HubSite:
                        setSelectedSharepointListId(null);
                        isLocationPinned = pinnedItems && isFolderPinned(null, selectedItem.id, pinnedItems);
                        break;

                    case LocationType.Site:
                        setSelectedSharepointListId(null);
                        isLocationPinned = pinnedItems && isFolderPinned(null, selectedItem.id, pinnedItems);
                        break;

                    case LocationType.TeamChannel:
                        setSelectedSharepointListId(null);
                        const teamItem = selectedItem as ITeamChannelLocation;
                        const cachedChannel = channels.find(channel => channel.id === teamItem.id) as ITeamChannelLocation;
                        if (!cachedChannel?.driveInfo) {
                            setIsTeamChannelInfoLoading(true);
                            const teamChannelInfo = await getTeamChannelInfo({ channelId: teamItem.id, driveId: currentDirectory.teamDriveId, groupId: currentDirectory.teamGroupId, isPrivate: teamItem.isPrivate, isShared: teamItem.isShared });

                            const channelsCopy = channels.slice();
                            for (const channel of channelsCopy) {
                                if (channel.id === teamItem.id) {
                                    (channel as ITeamChannelLocation).driveInfo = teamChannelInfo;
                                    break;
                                }
                            }
                            setChannels(channelsCopy);

                            isLocationPinned = pinnedItems && isFolderPinned(teamChannelInfo.driveId, teamChannelInfo.driveItemId, pinnedItems);
                            setIsTeamChannelInfoLoading(false);
                        }
                        else {
                            isLocationPinned = pinnedItems && isFolderPinned(cachedChannel.driveInfo.driveId, cachedChannel.driveInfo.driveItemId, pinnedItems);
                        }
                        break;

                    case LocationType.DocumentLibrary:
                        const documentLibraryItem = selectedItem as ISharepointListLocation;
                        setSelectedSharepointListId(documentLibraryItem.sharePointListId);
                        isLocationPinned = pinnedItems && isFolderPinned(documentLibraryItem.id, null, pinnedItems);
                        break;

                    case LocationType.SharepointList:
                        const sharepointListItem = selectedItem as ISharepointListLocation;
                        setSelectedSharepointListId(sharepointListItem.sharePointListId);
                        isLocationPinned = pinnedItems && isFolderPinned(sharepointListItem.id, null, pinnedItems);
                        break;

                    case LocationType.TessProject:
                        setSelectedSharepointListId(null);
                        isLocationPinned = pinnedItems && isFolderPinned(null, selectedItem.id, pinnedItems);
                        break;

                    case LocationType.Folder:
                        setSelectedSharepointListId(null);
                        isLocationPinned = pinnedItems && isFolderPinned(null, selectedItem.id, pinnedItems);
                        break;
                }

                setSelectedLocation({ ...selectedItem, isPinned: isLocationPinned });
            }
            else {
                setSelectedLocation(null);
                setSelectedSharepointListId(null);
            }
        })();
    }, [pinnedItems, selectedItems, currentDirectory?.webUrl]);

    React.useEffect(() => {
        const items: ICommandBarItemProps[] = allowOpenInSharePoint && (selectedLocation || currentDirectory?.webUrl)
            ? [
                {
                    key: "open",
                    disabled: isTeamChannelInfoLoading,
                    text: `${languageStrings.OpenIn} SharePoint`,
                    // iconProps: openInBrowserIconProps,
                    iconProps: {},
                    onClick: openLocationInBrowser,
                    // onRenderIcon: (isTeamChannelInfoLoading ? () => { return <Spinner size={SpinnerSize.small} style={{ paddingLeft: 3, paddingRight: 5 }} /> } : undefined)
                    onRenderIcon: () => {
                        return isTeamChannelInfoLoading
                            ? <Spinner size={SpinnerSize.small} style={{ paddingLeft: 3, paddingRight: 5 }} />
                            : <OpenFolder20Regular className={menuItemIconStyles} />
                    }
                }
            ]
            : [];

        if (selectedLocation) {
            items.push({
                key: "pinUnpin",
                disabled: selectedLocation == null || isTeamChannelInfoLoading,
                text: selectedLocation?.isPinned ? languageStrings.UnpinFolder : languageStrings.PinThisFolder,
                // iconProps: selectedLocation?.isPinned ? unpinIconProps : pinIconProps,
                iconProps: {},
                onClick: pinUnpinLocation,
                // onRenderIcon: (isTeamChannelInfoLoading ? () => { return <Spinner size={SpinnerSize.small} style={{ paddingLeft: 3, paddingRight: 5 }} /> } : undefined)
                onRenderIcon: () => {
                    return isTeamChannelInfoLoading
                        ? <Spinner size={SpinnerSize.small} style={{ paddingLeft: 3, paddingRight: 5 }} />
                        : selectedLocation?.isPinned
                            ? <PinOff20Regular className={menuItemIconStyles} />
                            : <Pin20Regular className={menuItemIconStyles} />
                }
            });

            if (selectedSharepointListId && tenantEnablePermissionManagement) {
                items.push({
                    key: "libraryPermissions",
                    text: languageStrings.LibraryPermissions,
                    // iconProps: permissionsIconProps,
                    iconProps: {},
                    onRenderIcon: () => <Key20Regular className={menuItemIconStyles} />,
                    onClick: () => {
                        setIsPermissionsPanelOpen(true);
                    },
                });
            }
        }
        else if (tenantEnablePermissionManagement) {
            items.push({
                key: "permissions",
                text: languageStrings.SitePermissions,
                // iconProps: permissionsIconProps,
                iconProps: {},
                onRenderIcon: () => <Key20Regular className={menuItemIconStyles} />,
                onClick: () => {
                    setIsPermissionsPanelOpen(true);
                },
            });
        }

        setCommandItems(items);

        const farItems: ICommandBarItemProps[] = [
            // {
            //     key: "advancedSearch",
            //     iconProps: advancedSearchIconProps,
            //     iconOnly: true,
            //     tooltipHostProps: {
            //         content: languageStrings.AdvancedSearch,
            //     },
            //     onClick: () => {
            //         // logMessage("Content manager Advanced search clicked", "Click");
            //         dispatch(setMode(ModeEnum.contentManagerAdvancedSearch));
            //     }
            // },
        ];

        // The all-documents view only makes sense where document sources are shown.
        // Tess directories qualify through their dossiers' SharePoint targets (libraries
        // AND folders — folder sources aggregate their subtree via RootFolder); one with
        // nothing aggregatable gets no switcher, matching the render branch's fallback.
        const showAllDocumentsToggle: boolean = isTessLocation
            ? hasTessAggregatableSources && !!allDocumentsScopeId
            : !currentDirectory?.isSharedTeam
                && (!hideDocumentLibrariesInTeams || !currentDirectory?.teamGroupId)
                && !!currentDirectory?.siteId;
        if (showAllDocumentsToggle) {
            // View-switcher dropdown, à la SharePoint's view selector: labeled with the
            // CURRENT view, chevron opens the list, checkmark marks the active entry.
            // Twin of the aggregate view's switcher — same entry order, both pinned
            // FIRST in the far items.
            farItems.push({
                key: "viewSwitcher",
                text: languageStrings.LocationsView,
                iconProps: {},
                onRenderIcon: () => <List20Regular className={menuItemIconStyles} />,
                // Submenu chevron is a font glyph — force the neutral foreground or it
                // renders in the theme accent color.
                buttonStyles: { menuIcon: { color: defaultFontColor } },
                ariaLabel: languageStrings.LocationsView,
                subMenuProps: {
                    items: [
                        {
                            key: "viewLocations",
                            text: languageStrings.LocationsView,
                            canCheck: true,
                            checked: true,
                        },
                        {
                            key: "viewAllDocuments",
                            text: languageStrings.AllDocuments,
                            canCheck: true,
                            checked: false,
                            onClick: () => {
                                toggleAllDocumentsView(true);
                            },
                        },
                    ],
                },
            });
        }

        farItems.push({
            key: "refresh",
            // iconProps: refreshIconProps,
            iconProps: {},
            onRenderIcon: () => <ArrowClockwise20Regular className={menuItemIconStyles} />,
            iconOnly: true,
            tooltipHostProps: {
                content: languageStrings.Refresh,
            },
            onClick: () => {
                refreshWithClientGroups();
            }
        });

        setCommandFarItems(farItems);
    }, [currentDirectory?.webUrl, tenantEnablePermissionManagement, selectedLocation, isTeamChannelInfoLoading, selectedSharepointListId, currentDirectory?.siteId, currentDirectory?.isSharedTeam, currentDirectory?.teamGroupId, isTessLocation, hasTessAggregatableSources, allDocumentsScopeId, hideDocumentLibrariesInTeams, toggleAllDocumentsView]);

    const openLocationInBrowser = React.useCallback((ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, item?: IContextualMenuItem) => {
        if (!selectedLocation) {
            window.open(currentDirectory.webUrl);
        }
        else {
            (async () => {
                switch (selectedLocation.type) {
                    case LocationType.HubSite:
                        window.open(selectedLocation.webUrl);
                        break;

                    case LocationType.Site:
                        window.open(selectedLocation.webUrl);
                        break;

                    case LocationType.TeamChannel:
                        const teamItem = selectedLocation as ITeamChannelLocation;
                        const cachedChannel = channels.find(channel => channel.id === teamItem.id) as ITeamChannelLocation;
                        if (!cachedChannel?.driveInfo) {
                            setIsTeamChannelInfoLoading(true);
                            const teamChannelInfo: ITeamChannelDocumentLibrary = await getTeamChannelInfo({ channelId: teamItem.id, driveId: currentDirectory.teamDriveId, groupId: currentDirectory.teamGroupId, isPrivate: teamItem.isPrivate, isShared: teamItem.isShared });
                            if (!teamChannelInfo) {
                                setIsTeamChannelInfoLoading(false);
                                showChannelErrorDialog();
                                break;
                            }
                            cachedChannel.driveInfo = teamChannelInfo;
                            setIsTeamChannelInfoLoading(false);
                        }
                        window.open(cachedChannel.driveInfo.driveItemWebUrl);
                        break;

                    case LocationType.DocumentLibrary:
                        window.open(selectedLocation.webUrl);
                        break;

                    case LocationType.SharepointList:
                        window.open(selectedLocation.webUrl);
                        break;

                    case LocationType.TessProject:
                        const project: ITessProjectLocation = selectedLocation as ITessProjectLocation;
                        if (Array.isArray(project.dossierMetadata) && project.dossierMetadata.length > 0) {
                            // const siteHit: IHit = await getSharePointSiteFromDriveId(project.dossierMetadata[0].driveId);
                            // if (siteHit) {
                            //     window.open(siteHit.resource.webUrl);
                            // }
                            const dossierSite = await getTessProjectSite(project.dossierMetadata);
                            if (dossierSite) {
                                window.open(dossierSite.webUrl);
                            }
                        }
                        break;

                    case LocationType.Folder:
                        window.open(selectedLocation.webUrl);
                        break;
                }
            })();
        }
    }, [currentDirectory?.webUrl, selectedLocation]);

    const pinUnpinLocation = React.useCallback((ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, item?: IContextualMenuItem) => {
        (async () => {
            const accountId: string = (await authModule.getAccount())?.accountId;
            let locations: IPageSettings[];
            let driveId: string;
            let itemId: string;
            let folderTypeIcon: FolderTypeIconEnum;
            let webUrl: string;
            let sharePointListId: string;
            let parentSiteId: string;
            let tessAccountId: string;
            let tessProjectId: string;
            let isList: boolean;

            switch (selectedLocation.type) {
                case LocationType.HubSite:
                    itemId = selectedLocation.id;
                    folderTypeIcon = FolderTypeIconEnum.sharepointHubSite;
                    webUrl = selectedLocation.webUrl;

                    if (!selectedLocation.isPinned) {
                        locations = [
                            ...workingDirectories,
                            ...[{
                                type: ComponentTypes.SharePointDocuments,
                                siteId: selectedLocation.id,
                                siteDisplayName: selectedLocation.displayName,
                                webUrl: selectedLocation.webUrl,
                                directory: "",
                                DocumentLibrary: "",
                                displayName: selectedLocation.displayName
                            }]
                        ];
                    }
                    break;

                case LocationType.Site:
                    itemId = selectedLocation.id;
                    folderTypeIcon = FolderTypeIconEnum.sharepointSite;
                    webUrl = selectedLocation.webUrl;

                    if (!selectedLocation.isPinned) {
                        locations = [
                            ...workingDirectories,
                            ...[{
                                type: ComponentTypes.SharePointDocuments,
                                siteId: selectedLocation.id,
                                siteDisplayName: selectedLocation.displayName,
                                webUrl: selectedLocation.webUrl,
                                directory: "",
                                DocumentLibrary: "",
                                displayName: selectedLocation.displayName
                            }]
                        ];
                    }
                    break;

                case LocationType.TeamChannel:
                    const teamItem = selectedLocation as ITeamChannelLocation;
                    const cachedChannel = channels.find(channel => channel.id === teamItem.id) as ITeamChannelLocation;
                    if (!cachedChannel?.driveInfo) {
                        setIsTeamChannelInfoLoading(true);
                        const teamChannelInfo: ITeamChannelDocumentLibrary = await getTeamChannelInfo({ channelId: teamItem.id, driveId: currentDirectory.teamDriveId, groupId: currentDirectory.teamGroupId, isPrivate: teamItem.isPrivate, isShared: teamItem.isShared });
                        if (!teamChannelInfo) {
                            setIsTeamChannelInfoLoading(false);
                            showChannelErrorDialog();
                            break;
                        }
                        cachedChannel.driveInfo = teamChannelInfo;
                        setIsTeamChannelInfoLoading(false);
                    }

                    driveId = cachedChannel.driveInfo.driveId;
                    itemId = cachedChannel.driveInfo.driveItemId;
                    folderTypeIcon = FolderTypeIconEnum.teamChannel;

                    if (!selectedLocation.isPinned) {
                        const teamsChannelLocation = getTeamsChannelLocationParts({ channel: teamItem, driveInfo: cachedChannel.driveInfo });
                        locations = [
                            ...workingDirectories,
                            ...[{
                                id: teamsChannelLocation.id,
                                parentId: teamsChannelLocation.parentId,
                                fileTitle: teamItem.displayName,
                                displayName: teamItem.displayName,
                                siteId: cachedChannel.driveInfo.siteId,
                                siteDisplayName: currentDirectory.siteDisplayName,
                                type: ComponentTypes.SharePointFolders,
                                directory: teamsChannelLocation.directory,
                                DocumentLibrary: cachedChannel.driveInfo.documentLibraryName,
                                isTeamsRootFolder: true,
                                isTeamsFolder: true,
                                isPrivateTeamsChannel: teamItem.isPrivate,
                                isSharedTeamsChannel: teamItem.isShared,
                                sharePointListId: cachedChannel.driveInfo.sharePointListId,
                                webUrl: cachedChannel.driveInfo.sharePointSiteUrl,
                                teamChannelId: teamItem.id
                            }]
                        ];
                    }
                    break;

                case LocationType.DocumentLibrary:
                    const documentLibraryItem = selectedLocation as ISharepointListLocation;

                    driveId = documentLibraryItem.id;
                    folderTypeIcon = FolderTypeIconEnum.documentLibrary;
                    webUrl = documentLibraryItem.webUrl;
                    sharePointListId = documentLibraryItem.sharePointListId;

                    if (!selectedLocation.isPinned) {
                        locations = [
                            ...workingDirectories,
                            ...[{
                                fileTitle: documentLibraryItem.displayName,
                                displayName: documentLibraryItem.displayName,
                                webUrl: currentDirectory.webUrl,
                                siteId: currentDirectory.siteId,
                                siteDisplayName: currentDirectory.siteDisplayName,
                                id: documentLibraryItem.id,
                                parentId: null,
                                type: ComponentTypes.SharePointFolders,
                                directory: !currentDirectory.directory ? (documentLibraryItem.webUrl ? `${getLastSplittedStringItem(documentLibraryItem.webUrl, /[\s/]+/)}` : documentLibraryItem.displayName) : `${currentDirectory.directory}/${documentLibraryItem.displayName}`,
                                DocumentLibrary: currentDirectory.DocumentLibrary?.length > 0 ? currentDirectory.DocumentLibrary : documentLibraryItem.displayName,
                                isTeamsFolder: false,
                                isTeamsRootFolder: false,
                                sharePointListId: documentLibraryItem.sharePointListId,
                            }]
                        ];
                    }
                    break;

                case LocationType.SharepointList:
                    const sharepointListItem = selectedLocation as ISharepointListLocation;

                    driveId = sharepointListItem.id;
                    folderTypeIcon = FolderTypeIconEnum.sharepointList;
                    webUrl = sharepointListItem.webUrl;
                    sharePointListId = sharepointListItem.sharePointListId;
                    isList = true;

                    if (!currentDirectory.siteId) {
                        const site = workingDirectories.filter(x => x.siteId).slice(-1)[0] as IPageSettings;
                        parentSiteId = site.siteId;
                    }

                    if (!selectedLocation.isPinned) {
                        locations = [
                            ...workingDirectories,
                            ...[{
                                fileTitle: sharepointListItem.displayName,
                                displayName: sharepointListItem.displayName,
                                webUrl: currentDirectory.webUrl,
                                siteId: currentDirectory.siteId ? currentDirectory.siteId : parentSiteId,
                                siteDisplayName: currentDirectory.siteDisplayName,
                                id: sharepointListItem.id,
                                parentId: null,
                                type: ComponentTypes.SharePointList,
                                directory: !currentDirectory.directory ? (sharepointListItem.webUrl ? `${getLastSplittedStringItem(sharepointListItem.webUrl, /[\s/]+/)}` : sharepointListItem.displayName) : `${currentDirectory.directory}/${sharepointListItem.displayName}`,
                                DocumentLibrary: currentDirectory.DocumentLibrary?.length > 0 ? currentDirectory.DocumentLibrary : sharepointListItem.displayName,
                                isTeamsFolder: false,
                                isTeamsRootFolder: false,
                                sharePointListId: sharepointListItem.sharePointListId,
                            }]
                        ];
                    }
                    break;

                case LocationType.TessProject:
                    itemId = selectedLocation.id;
                    folderTypeIcon = FolderTypeIconEnum.sharepointSite;

                    if (!selectedLocation.isPinned) {
                        const project: ITessProjectLocation = selectedLocation as ITessProjectLocation;
                        if (Array.isArray(project.dossierMetadata) && project.dossierMetadata.length > 0) {
                            // const siteHit: IHit = await getSharePointSiteFromDriveId(project.dossierMetadata[0].driveId);
                            // if (siteHit) {
                            //     webUrl = siteHit.resource.webUrl;
                            // }
                            const dossierSite = await getTessProjectSite(project.dossierMetadata);
                            if (dossierSite) {
                                webUrl = dossierSite.webUrl;
                            }
                        }

                        tessAccountId = workingDirectories.find(x => x.tessAccountId)?.tessAccountId;
                        tessProjectId = project.tessProjectId;

                        locations = [
                            ...workingDirectories,
                            ...[{
                                type: ComponentTypes.TessProject,
                                siteDisplayName: selectedLocation.displayName,
                                directory: "",
                                DocumentLibrary: "",
                                displayName: selectedLocation.displayName,
                                tessAccountId,
                                tessProjectId
                            }]
                        ];
                    }
                    break;

                case LocationType.Folder:
                    const sharepointFolderItem = selectedLocation as ISharepointFolderLocation;

                    itemId = sharepointFolderItem.id;
                    driveId = sharepointFolderItem.driveId;
                    folderTypeIcon = FolderTypeIconEnum.sharepointFolder;
                    sharePointListId = sharepointFolderItem.sharePointListId;
                    let siteDisplayName: string;

                    if (!selectedLocation.isPinned) {
                        const project: ITessProjectLocation = selectedLocation as ITessProjectLocation;
                        if (Array.isArray(project.dossierMetadata) && project.dossierMetadata.length > 0) {
                            // const siteHit: IHit = await getSharePointSiteFromDriveId(project.dossierMetadata[0].driveId);
                            // if (siteHit) {
                            //     webUrl = siteHit.resource.webUrl;
                            //     parentSiteId = siteHit.resource.id;
                            //     siteDisplayName = siteHit.resource.displayName;
                            // }
                            const dossierSite = await getTessProjectSite(project.dossierMetadata);
                            if (dossierSite) {
                                webUrl = dossierSite.webUrl;
                                parentSiteId = dossierSite.id;
                                siteDisplayName = dossierSite.displayName;
                            }
                        }

                        const accessToken = await authModule.getGraphAccessToken();
                        const documentLibraryData = await getItemCustomSelect(accessToken, driveId, null, "id,name,webDavUrl");

                        if (documentLibraryData) {
                            locations = [
                                ...workingDirectories,
                                ...[{
                                    fileTitle: documentLibraryData.name,
                                    displayName: documentLibraryData.name,
                                    webUrl: webUrl,
                                    siteId: parentSiteId,
                                    siteDisplayName: siteDisplayName,
                                    id: documentLibraryData.id,
                                    type: ComponentTypes.SharePointFolders,
                                    directory: tryGetSiteRelativeUrl(webUrl, tryDecodeUriComponent(new URL(documentLibraryData.webDavUrl).pathname)),
                                    DocumentLibrary: documentLibraryData.name,
                                    sharePointListId: sharePointListId
                                }],
                                ...[{
                                    id: sharepointFolderItem.id,
                                    parentId: sharepointFolderItem.driveId,
                                    type: ComponentTypes.SharePointFolders,
                                    siteId: parentSiteId,
                                    siteDisplayName: siteDisplayName,
                                    webUrl: webUrl,
                                    fileTitle: sharepointFolderItem.displayName,
                                    directory: tryGetSiteRelativeUrl(sharepointFolderItem.webUrl, sharepointFolderItem.path),
                                    DocumentLibrary: documentLibraryData?.name,
                                    displayName: sharepointFolderItem.displayName,
                                    isTeamsFolder: false,
                                    sharePointListId: sharepointFolderItem.sharePointListId,
                                    contentTypeId: sharepointFolderItem.contentTypeId,
                                    serverRelativePath: sharepointFolderItem.path,
                                    sharePointUniqueId: sharepointFolderItem.sharePointUniqueId
                                }]
                            ];
                        }
                    }
                    break;
            }

            if (selectedLocation.isPinned) {
                dispatch(removePinnedItem(accountId, { driveId: driveId, itemId: itemId }, FileTypeEnum.folder));
            }
            else {
                const pinItem: IStoreItem = {
                    driveId: driveId,
                    locations: [...locations],
                    name: selectedLocation.displayName,
                    itemId: itemId,
                    fileType: FileTypeEnum.folder,
                    folderTypeIcon: folderTypeIcon,
                    datePinned: new Date(),
                    folderId: itemId,
                    webUrl: webUrl,
                    sharePointListId: sharePointListId,
                    siteId: parentSiteId ? parentSiteId : currentDirectory.siteId,
                    isList: isList,
                    tessAccountId,
                    tessProjectId
                };
                dispatch(addPinnedItem(accountId, pinItem));
            }
        })();
    }, [selectedLocation]);

    const getLocationImage = React.useCallback((item: ILocation): JSX.Element => {
        let icon: JSX.Element;
        switch (item.type) {
            case LocationType.HubSite:
                icon = <SquareMultiple20Regular />;
                break;

            case LocationType.Site:
                icon = <img
                    src={BrandIcons.SharePoint20}
                    width="20"
                    height="20"
                    alt="SharePoint site icon"
                />;
                break;

            case LocationType.TeamChannel:
                icon = <Channel20Regular />;
                break;

            case LocationType.DocumentLibrary:
                icon = <FolderDocument20Regular />;
                break;

            case LocationType.SharepointList:
                icon = <Icon
                    {...getFileTypeIconProps({
                        type: FileIconType.list,
                        size: 20,
                        imageFileType: "svg",
                    })}
                />;
                break;

            case LocationType.TessProject:
                icon = <img
                    src={BrandIcons.SharePoint20}
                    width="20"
                    height="20"
                    alt="SharePoint subsite icon"
                />;
                break;

            case LocationType.Folder:
                icon = <Icon
                    {...getFileTypeIconProps({
                        type: FileIconType.folder,
                        size: 20,
                        imageFileType: "svg",
                    })}
                />;
                break;

            default:
                icon = <Icon />;
                break;
        }

        // Grey the icon for site rows (hubs/subsites/tess projects) flagged inactive by the global client list.
        if (isLocationInactive(item)) {
            return <span style={{ opacity: 0.4, filter: "grayscale(1)", display: "inline-flex" }}>{icon}</span>;
        }

        return icon;
    }, []);

    const browseDocumentLibraryOrFolder = async (item: ILocation) => {
        try {
            const documentLibraryItem = item as ISharepointListLocation;
            const isFolder: boolean = documentLibraryItem.contentTypeId === SharePointFolderContentTypeIds.folder;
            // Only a library can be a client-group site's: a Tess folder carries a site id and url too.
            const groupLibraryDirectories = isFolder ? null : buildGroupLibraryDirectories(documentLibraryItem, clientGroupAggregateSites, currentDirectory?.siteId);
            if (isFolder) {
                const folderItem = item as ISharepointFolderLocation;
                const accessToken = await authModule.getGraphAccessToken();
                const documentLibraryData = await getItemCustomSelect(accessToken, folderItem.driveId, null, "id,name");
                const folderToAdd: IPageSettings = {
                    id: folderItem.id,
                    parentId: folderItem.driveId,
                    type: ComponentTypes.SharePointFolders,
                    siteId: workingDirectories.find(x => x.siteId)?.siteId,
                    siteDisplayName: workingDirectories.find(x => x.siteDisplayName)?.siteDisplayName,
                    webUrl: folderItem.siteUrl,
                    fileTitle: folderItem.displayName,
                    directory: tryGetSiteRelativeUrl(folderItem.webUrl, folderItem.path),
                    DocumentLibrary: documentLibraryData?.name,
                    displayName: folderItem.displayName,
                    isTeamsFolder: false,
                    sharePointListId: folderItem.sharePointListId,
                    contentTypeId: folderItem.contentTypeId,
                    serverRelativePath: folderItem.path,
                    sharePointUniqueId: folderItem.sharePointUniqueId
                };
                dispatch(addWorkingDirectory(folderToAdd));
            }
            else if (groupLibraryDirectories) {
                // A client-group site's library (All documents): opened under ITS site, the
                // site first and then the library, in one step and one history entry.
                dispatch(addWorkingDirectories(groupLibraryDirectories));
            }
            else {
                const itemToAdd: IPageSettings = {
                    id: item.id,
                    type: ComponentTypes.SharePointFolders,
                    siteId: currentDirectory.siteId,
                    siteDisplayName: currentDirectory.siteDisplayName,
                    webUrl: documentLibraryItem.siteUrl || currentDirectory.webUrl,
                    fileTitle: documentLibraryItem.displayName,
                    directory: documentLibraryItem.siteUrl && documentLibraryItem.webUrl
                        ? documentLibraryItem.webUrl.replace(documentLibraryItem.siteUrl, "")
                        : getLastSplittedStringItem(documentLibraryItem.webUrl, /[\s/]+/),
                    DocumentLibrary: documentLibraryItem.displayName,
                    displayName: documentLibraryItem.displayName,
                    isTeamsFolder: currentDirectory.isTeamsFolder,
                    sharePointListId: documentLibraryItem.sharePointListId
                };

                const sharepointListItemIndex = workingDirectories.findIndex(x => x.sharePointListId);
                if (sharepointListItemIndex === -1) {
                    dispatch(addWorkingDirectory(itemToAdd));
                } else {
                    dispatch(removeDirectoriesByIndexAndAddItem(sharepointListItemIndex, itemToAdd));
                }
            }
        } catch (error) {
            logger(error, "ContentBodyLibraries.tsx (browseDocumentLibraryOrFolder)");
        }
    }

    const getLocationLink = React.useCallback((item: ILocation): JSX.Element => {
        try {
            switch (item.type) {
                case LocationType.HubSite:
                    return <Link
                        data-selection-disabled={true}
                        rel="noopener"
                        styles={detailRowLinkStyles}
                        onClick={() => {
                            const itemToAdd: IPageSettings = {
                                type: ComponentTypes.SharePointDocuments,
                                siteId: item.id,
                                siteDisplayName: item.displayName,
                                webUrl: item.webUrl,
                                directory: "",
                                DocumentLibrary: "",
                                displayName: item.displayName,
                                isHub: item.isHub,
                                hubId: item.hubId,
                                parentHubId: item.parentHubId
                            };
                            dispatch(addWorkingDirectory(itemToAdd));
                        }}
                    >
                        <Stack horizontal verticalAlign="center" tokens={gridLinkStackTokens}>
                            <span style={isLocationInactive(item) ? { opacity: 0.4 } : undefined}>{item.displayName}</span>
                            {isLocationInactive(item) &&
                                <TooltipHost content={languageStrings.InactiveClient}><PauseCircle20Regular /></TooltipHost>}
                        </Stack>
                    </Link>

                case LocationType.Site:
                    return <Link
                        data-selection-disabled={true}
                        rel="noopener"
                        styles={detailRowLinkStyles}
                        onClick={() => {
                            const itemToAdd: IPageSettings = {
                                type: ComponentTypes.SharePointDocuments,
                                siteId: item.id,
                                siteDisplayName: item.displayName,
                                webUrl: item.webUrl,
                                directory: "",
                                DocumentLibrary: "",
                                displayName: item.displayName,
                                tessProjectId: item.tessProjectId
                            };
                            dispatch(addWorkingDirectory(itemToAdd));
                        }}
                    >
                        <Stack horizontal verticalAlign="center" tokens={gridLinkStackTokens}>
                            <span style={isLocationInactive(item) ? { opacity: 0.4 } : undefined}>{item.displayName}</span>
                            {isLocationInactive(item) &&
                                <TooltipHost content={languageStrings.InactiveClient}><PauseCircle20Regular /></TooltipHost>}
                        </Stack>
                    </Link>

                case LocationType.TeamChannel:
                    return <Link
                        data-selection-disabled={true}
                        rel="noopener"
                        styles={detailRowLinkStyles}
                        onClick={async () => {
                            dispatch(setIsContentManagerContentLoading(true));
                            const teamItem = item as ITeamChannelLocation;
                            const teamChannelInfo = await getTeamChannelInfo({ channelId: teamItem.id, driveId: currentDirectory.teamDriveId, groupId: currentDirectory.teamGroupId, isPrivate: teamItem.isPrivate, isShared: teamItem.isShared });
                            if (!teamChannelInfo) {
                                dispatch(setIsContentManagerContentLoading(false));
                                showChannelErrorDialog();
                                return;
                            }
                            const teamsChannelLocation = getTeamsChannelLocationParts({ channel: teamItem, driveInfo: teamChannelInfo });
                            const itemToAdd: IPageSettings = {
                                id: teamsChannelLocation.id,
                                parentId: teamsChannelLocation.parentId,
                                type: ComponentTypes.SharePointFolders,
                                siteId: teamChannelInfo.siteId,
                                siteDisplayName: currentDirectory.siteDisplayName,
                                webUrl: teamChannelInfo.sharePointSiteUrl,
                                fileTitle: teamItem.displayName,
                                directory: teamsChannelLocation.directory,
                                DocumentLibrary: teamChannelInfo.documentLibraryName,
                                displayName: teamItem.displayName,
                                isTeamsRootFolder: true,
                                isTeamsFolder: currentDirectory.isTeamsFolder,
                                isPrivateTeamsChannel: teamItem.isPrivate,
                                isSharedTeamsChannel: teamItem.isShared,
                                sharePointListId: teamChannelInfo.sharePointListId,
                                teamChannelId: teamItem.id
                            };
                            dispatch(setIsContentManagerContentLoading(false));
                            dispatch(addWorkingDirectory(itemToAdd));
                        }}
                    >
                        <Stack horizontal verticalAlign="center" tokens={gridLinkStackTokens}>
                            <span>{item.displayName}</span>
                            {(item as ITeamChannelLocation)?.isPrivate && <ChannelPrivateIcon />}
                            {(item as ITeamChannelLocation)?.isShared && <ChannelShareIcon />}
                        </Stack>
                    </Link>

                case LocationType.DocumentLibrary:
                    return <Link
                        data-selection-disabled={true}
                        rel="noopener"
                        styles={detailRowLinkStyles}
                        onClick={() => {
                            browseDocumentLibraryOrFolder(item);
                        }}
                    >
                        {item.displayName}
                    </Link>

                case LocationType.SharepointList:
                    return <Link
                        data-selection-disabled={true}
                        rel="noopener"
                        styles={detailRowLinkStyles}
                        onClick={() => {
                            const sharepointListItem = item as ISharepointListLocation;

                            const itemToAdd: IPageSettings = {
                                id: item.id,
                                type: ComponentTypes.SharePointList,
                                siteId: currentDirectory.siteId,
                                siteDisplayName: currentDirectory.siteDisplayName,
                                webUrl: currentDirectory.webUrl,
                                fileTitle: sharepointListItem.displayName,
                                directory: getLastSplittedStringItem(sharepointListItem.webUrl, /[\s/]+/),
                                sharepointList: sharepointListItem.displayName,
                                displayName: sharepointListItem.displayName,
                                isTeamsFolder: currentDirectory.isTeamsFolder,
                                sharePointListId: sharepointListItem.sharePointListId
                            };

                            const sharepointListItemIndex = workingDirectories.findIndex(x => x.sharePointListId);
                            if (sharepointListItemIndex === -1) {
                                dispatch(addWorkingDirectory(itemToAdd));
                            } else {
                                dispatch(removeDirectoriesByIndexAndAddItem(sharepointListItemIndex, itemToAdd));
                            }
                        }}
                    >
                        {item.displayName}
                    </Link>

                case LocationType.TessProject:
                    return <Link
                        data-selection-disabled={true}
                        rel="noopener"
                        styles={detailRowLinkStyles}
                        onClick={() => {
                            const itemToAdd: IPageSettings = {
                                type: ComponentTypes.TessProject,
                                siteDisplayName: item.displayName,
                                directory: "",
                                DocumentLibrary: "",
                                displayName: item.displayName,
                                tessAccountId: workingDirectories.find(x => x.tessAccountId)?.tessAccountId,
                                tessProjectId: item.tessProjectId
                            };
                            dispatch(addWorkingDirectory(itemToAdd));
                        }}
                    >
                        <Stack horizontal verticalAlign="center" tokens={gridLinkStackTokens}>
                            <span style={isLocationInactive(item) ? { opacity: 0.4 } : undefined}>{item.displayName}</span>
                            {isLocationInactive(item) &&
                                <TooltipHost content={languageStrings.InactiveClient}><PauseCircle20Regular /></TooltipHost>}
                        </Stack>
                    </Link>

                case LocationType.Folder:
                    return <Link
                        data-selection-disabled={true}
                        rel="noopener"
                        styles={detailRowLinkStyles}
                        onClick={async () => {
                            dispatch(setIsContentManagerContentLoading(true));
                            browseDocumentLibraryOrFolder(item);
                            dispatch(setIsContentManagerContentLoading(false));
                        }}
                    >
                        {item.displayName}
                    </Link>

                default:
                    return <Label>{item.displayName}</Label>;
            }
        } catch (error) {
            logger(error, "ContentBodyLibraries.tsx (getLocationLink)");
            return <Label>{item.displayName}</Label>;
        }
    }, [currentDirectory]);

    const getLocationTypeText = React.useCallback((item: ILocation): JSX.Element => {
        switch (item.type) {
            case LocationType.HubSite:
                return <span>{languageStrings.HubSite}</span>;

            case LocationType.Site:
                return <span>{item.isSubsite ? languageStrings.SharepointSubsite : languageStrings.SharepointSite}</span>;

            case LocationType.TeamChannel:
                return <span>{"Team channel"}</span>;

            case LocationType.DocumentLibrary:
                return <span>{languageStrings.DocumentLibrary}</span>;

            case LocationType.SharepointList:
                return <span>{languageStrings.List}</span>;

            case LocationType.TessProject:
                return <span>{"Project"}</span>;

            default:
                return <span />;
        }
    }, []);

    const setSharepointListLocationItemCount = React.useCallback((allListCount: IListInfo[], locations: ISharepointListLocation[], syncTopLevelCount: boolean = false): void => {
        if (allListCount?.length > 0) {
            locations.forEach(location => {
                const list: IListInfo = allListCount.find(list => list.Id === location.sharePointListId);
                if (list) {
                    const listItemCount: number = list.ItemCount;
                    location.itemCount = listItemCount;
                    if (syncTopLevelCount || listItemCount === 0) {
                        location.rootItemCount = listItemCount;
                    }
                }
            });
        }
    }, []);

    /**
     * Publishes a root-item-count update (a count, or the spinner flag) to the grid.
     *
     * The counts are written onto the location objects IN PLACE, and those objects are
     * already inside `items` — so setDocumentLibraries alone changes nothing Fluent can
     * see. Its List refuses to re-render while the items array it mounted with keeps its
     * identity, and the GroupedList above it only revs the version that would override
     * that when `items` or `groups` change identity. A mutated cell therefore never
     * repaints, and the column sits blank however many counts have landed.
     *
     * The locations list gets away with it on a fresh site load only by accident: the
     * grid mounts mid-shimmer, so the shimmer→items swap marks it permanently dirty.
     * Switching in from the aggregate view has no such swap — the grid mounts already
     * loaded — which is exactly where the counts and their spinners went missing.
     *
     * Groups rather than items: re-publishing `items` would also re-run Fluent's
     * selection reset (this list passes no setKey), dropping the user's row selection
     * on every count that lands. Re-publishing the same groups in a new array is the
     * cheapest thing that reaches the rows, and group state lives on the group objects
     * themselves, which are kept.
     */
    const publishRootItemCounts = React.useCallback((locations: ISharepointListLocation[]): void => {
        // Batched because this fires once per library that finishes, and each publish now
        // re-renders the grid rows for real: legacy-mode React does not batch updates made
        // from a promise continuation, so the two setters would cost two full renders every
        // time. A no-op under React 18's automatic batching — safe to leave in place across
        // an upgrade rather than something that has to be undone.
        unstable_batchedUpdates(() => {
            setDocumentLibraries([...locations]);
            setGroups(currentGroups => currentGroups ? [...currentGroups] : currentGroups);
        });
    }, []);

    const updateSharepointLibraryRootFolderCount = React.useCallback(async (webUrl: string, locations: ISharepointListLocation[]): Promise<void> => {
        // Bound ONCE, to the service this run belongs to. Re-reading the ref at each check
        // made the guard useless across a refresh: the load effect's cleanup cancels
        // whichever service is current at that moment, and the reload immediately installs a
        // fresh, UNCANCELLED one for the same web — so a superseded run's checks passed
        // against the new token and it kept fetching and publishing its stale array over the
        // new load's. Every reload constructs a new service, so instance identity IS this
        // run's generation, and React always runs the cleanup before re-running the effect.
        //
        // The null check closes a second hole: a missing service used to throw a TypeError
        // inside this unawaited promise, i.e. an invisible unhandled rejection.
        const service = cancellableSharePointRestApiService.current;
        if (service && locations?.filter(location => location.itemCount > 0)?.length > 0) {
            const timeout = setTimeout(() => {
                if (!service.getIsCancellationRequested(webUrl)) {
                    for (let l = 0; l < locations.length; l++) {
                        // itemCount > 0 mirrors the fetch loop below EXACTLY: a location it
                        // will not fetch is one nothing will ever clear the flag for, and
                        // its cell would spin for the rest of the session. An itemCount of
                        // zero already carries its root count; undefined means the list was
                        // missing from the counts response, so there is nothing to wait for.
                        if (locations[l].rootItemCount === undefined && locations[l].itemCount > 0) {
                            locations[l].isCalculatingRootItemCount = true;
                        }
                    }
                    publishRootItemCounts(locations);
                }
            }, 1000);

            for (let i = 0; i < locations.length; i += 20) {
                // Superseded mid-run: stop paging instead of walking every remaining slice
                // to do nothing in each one.
                if (service.getIsCancellationRequested(webUrl)) {
                    break;
                }

                const locationsSlices: ISharepointListLocation[] = locations.slice(i, i + 20);

                await Promise.all(locationsSlices.map(async location => {
                    if (location.itemCount > 0) {
                        if (!service.getIsCancellationRequested(webUrl)) {
                            let rootItemCount: number = await service.getSharepointLibraryRootItemCount(webUrl, location.sharePointListId);
                            if (rootItemCount > location.itemCount) {
                                rootItemCount = location.itemCount;
                            }
                            location.rootItemCount = rootItemCount;
                            location.isCalculatingRootItemCount = false;

                            if (!service.getIsCancellationRequested(webUrl)) {
                                publishRootItemCounts(locations);
                            }
                        }
                    }
                }));
            }

            clearTimeout(timeout);
        }
    }, [currentDirectory, publishRootItemCounts]);

    /**
     * The root-item-count fan-out runs once per locations load however many times its
     * trigger fires — claimed on the load tracker's current generation.
     *
     * Needed because there are two triggers: the load itself (when the locations list is
     * already on screen) and the deferred effect below (when the user switches to it
     * later). updateSharepointLibraryRootFolderCount mutates the locations array in place,
     * batches twenty at a time and arms a one-second spinner timer — two concurrent runs
     * would interleave all three.
     *
     * Per GENERATION, not per site URL: keyed on the URL, a trigger that fired before the
     * site's libraries had arrived armed the guard for that site and then blocked the real
     * fan-out, leaving the column blank. Every load begins a new generation, so a refresh
     * or a site change re-arms it.
     */
    const ensureRootItemCounts = React.useCallback((webUrl: string, locations: ISharepointListLocation[]): void => {
        // The claim is last: it is a side effect, and must not be spent on a no-op call.
        if (!webUrl || !(locations?.length > 0) || !loadTrackerRef.current.claimRootItemCounts()) {
            return;
        }
        updateSharepointLibraryRootFolderCount(webUrl, locations);
    }, [updateSharepointLibraryRootFolderCount]);

    // Deferred trigger. The counts feed ONE thing — the "Top level items" column — so the
    // load skips them whenever the aggregate grid is what will render. But the locations
    // list can come back WITHOUT a remount (the view switcher, or an armed copy/move
    // forcing it), and the load effect will not re-run, so the counts have to be picked up
    // here instead. Without this the column would sit permanently blank: its fallback for
    // an undefined count that is not calculating is to render nothing at all.
    React.useEffect(() => {
        if (!isLocationsListVisible || !currentDirectory?.webUrl) {
            return;
        }
        // Same exclusion as the load-path call. Tess locations DO populate
        // documentLibraries (from the Tess project content, not getLocationDocumentLibraries),
        // so without this the deferred trigger would fan out where the eager one never did.
        if (isTessLocation) {
            return;
        }
        const libraries = documentLibraries as ISharepointListLocation[];
        // Nothing outstanding — every library either has its count or was pre-filled as
        // empty. Avoids arming the guard (and the spinner) for a no-op fan-out.
        if (!(libraries?.length > 0) || libraries.every(library => library.rootItemCount !== undefined)) {
            return;
        }
        ensureRootItemCounts(currentDirectory.webUrl, libraries);
    }, [isLocationsListVisible, currentDirectory?.webUrl, isTessLocation, documentLibraries, ensureRootItemCounts]);

    // The sections as they stand, for the paths that recompose the grid after the load (a column
    // sort, late client group sections). The section order itself comes from locationSections.ts,
    // the same list the load uses.
    const currentSectionInput = (sortRows: (rows: ILocation[] | undefined) => ILocation[] | undefined): ILocationSectionInput<ILocation> => ({
        hubAssociatedHubs: sortRows(hubAssociatedHubs),
        hubAssociatedSites: sortRows(hubAssociatedSites),
        subSites: sortRows(subSites),
        channels: sortRows(channels),
        tessProjectFolders: sortRows(tessProjectFolders),
        documentLibraries: sortRows(documentLibraries),
        clientGroupSites: sortRows(clientGroupMembers),
        clientGroups: clientGroupParents.map(group => ({ ...group, items: sortRows(group.items) })),
        tessActiveProjects: sortRows(tessActiveProjectSites),
        tessDraftProjects: sortRows(tessDraftProjectSites),
        tessFinishedProjects: sortRows(tessFinishedProjectSites),
        sharepointLists: sortRows(sharepointLists)
    });

    const onColumnHeaderClick = React.useCallback((ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const newColumns: IColumn[] = columns.slice();
        const currColumn: IColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
        newColumns.forEach((newCol: IColumn) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });

        // Sorted within each section.
        const sortRows = (rows: ILocation[] | undefined): ILocation[] => _copyAndSort(rows ?? [], currColumn.fieldName!, currColumn.isSortedDescending);
        const { items: newItems } = composeLocationSections(orderLocationSections<ILocation>(currentSectionInput(sortRows), languageStrings));
        userSortRef.current = { fieldName: currColumn.fieldName!, isSortedDescending: !!currColumn.isSortedDescending };
        setColumns(newColumns);
        setItems(newItems);
        setSortRevision(revision => revision + 1);
    }, [columns, hubAssociatedHubs, hubAssociatedSites, clientGroupMembers, clientGroupParents, subSites, channels, documentLibraries, tessActiveProjectSites, tessDraftProjectSites, tessFinishedProjectSites, sharepointLists, tessProjectFolders, languageStrings, setColumns, setItems]);

    // Late client group sections join the grid, recomposed from the sections as they stand (a row
    // removed meanwhile stays removed), sorted as the user sorted since the load, with the
    // collapsed groups carried over; setKey is unchanged, so the row selection stays too.
    React.useEffect(() => {
        if (lateClientGroupRevision === 0) {
            return;
        }
        const sort = userSortRef.current;
        const sortRows = (rows: ILocation[] | undefined): ILocation[] | undefined => sort ? _copyAndSort(rows ?? [], sort.fieldName, sort.isSortedDescending) : rows;
        const { groups: composedGroups, items: newItems } = composeLocationSections(orderLocationSections<ILocation>(currentSectionInput(sortRows), languageStrings));
        unstable_batchedUpdates(() => {
            setItems(newItems);
            setGroups(currentGroups => carryCollapsedGroups(composedGroups, currentGroups));
        });
    }, [lateClientGroupRevision]);

    const channelDialogContentProps = {
        type: DialogType.largeHeader,
        title: languageStrings.TeamsChannel,
        closeButtonAriaLabel: "Close",
        subText: languageStrings.TeamsChannelNotLoaded
    };

    const channelErrorDialog = !isChannelErrorDialogHidden && (
        <Dialog hidden={false} onDismiss={hideChannelErrorDialog} dialogContentProps={channelDialogContentProps}>
            <DialogFooter>
                <PrimaryButton autoFocus onClick={hideChannelErrorDialog} text="Ok" />
            </DialogFooter>
        </Dialog>
    );

    const _onRenderDetailsHeader: IDetailsListProps['onRenderDetailsHeader'] = props => {
        if (props) {
            return <DetailsHeader {...props} isAllCollapsed={groups?.length > 0 ? !groups?.some(g => !g.isCollapsed) : false} />;
        }
        return null;
    };

    const onGridItemDrop = async (item) => {
        browseDocumentLibraryOrFolder(item);
    }

    const onDragHover = async (item) => {
        browseDocumentLibraryOrFolder(item);
    }

    const _onRenderRow: IDetailsListProps['onRenderRow'] = rowProps => {
        return (
            <DraggableContainer isValidDropZone={rowProps.item.type === LocationType.DocumentLibrary || rowProps.item.type === LocationType.Folder} onDragHover={() => onDragHover(rowProps.item)} onDropBeforeFiles={() => { generalModule.setOpenPanelUploadPanel(true), setIsUploadingFiles(true) }} onDropAfterFiles={() => onGridItemDrop(rowProps.item)}>
                <DetailsRow {...rowProps} />
            </DraggableContainer>
        )
    }

    // Exact complement of isLocationsListVisible, which gates the root-item-count
    // fan-out — expressed through it so a future change to one cannot silently leave the
    // "Top level items" column blank or restore the wasted fetch.
    if (!isLocationsListVisible) {
        return (
            <ContentBodyAllDocuments
                // Remount per library set: filters/search/sort/selection are scoped to
                // the columns of the libraries on screen — carrying them across
                // navigation could filter site B by a column it doesn't have (blanking
                // the grid with a stale filter).
                //
                // siteId alone would be that identity if one siteId always meant one
                // library set, and Tess already breaks that: its directories inherit
                // siteId from the nearest ancestor, so a project and its parent site
                // share one. The Tess ids are folded in to keep the key honest for
                // anything else that inherits a parent's siteId — undefined for an
                // ordinary site, which leaves today's per-site behaviour untouched.
                // The same identity the loaded content above is scoped to, so the grid
                // and the content it is handed can never disagree about which directory
                // they belong to.
                key={directoryContentKey}
                siteId={currentDirectory?.siteId}
                siteWebUrl={currentDirectory?.webUrl}
                // At a Tess directory the "everything on this surface" label is the
                // account/project itself, not the ancestor site the ids inherit from —
                // it feeds the copy/move source label when a selection spans sources.
                siteDisplayName={isTessLocation
                    ? currentDirectory?.displayName ?? currentDirectory?.siteDisplayName
                    : currentDirectory?.siteDisplayName}
                libraries={documentLibraries as ISharepointListLocation[]}
                // Folder-shaped Tess dossiers: each aggregates one folder subtree.
                // Empty for plain sites, so nothing site-shaped changes.
                folders={tessProjectFolders as ISharepointFolderLocation[]}
                viewScopeId={allDocumentsScopeId}
                isLoadingLibraries={isLoading}
                // Client-group sites: their libraries load alongside the site's own documents. While
                // the lookup is still out, the view holds its first paint as it does for their libraries.
                groupSites={clientGroupAggregateSites}
                isResolvingGroupSites={isResolvingClientGroups}
                onRefreshGroupSites={refreshClientGroupMembership}
                onSwitchToLocations={() => toggleAllDocumentsView(false)}
                onOpenLibrary={browseDocumentLibraryOrFolder}
            />
        );
    }

    return (
        <>
            <CommandBar
                styles={commandBarStyle}
                items={commandItems}
                farItems={commandFarItems}
                ariaLabel="Use left and right arrow keys to navigate between commands"
            />
            <div className={classNames.wrapper}>
                <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                    {!isUploadingFiles && <ShimmeredDetailsList
                        compact={false}
                        items={items || []}
                        columns={columns}
                        groups={groups}
                        groupProps={{ onRenderHeader: renderCollapsibleGroupHeader }}
                        selectionMode={SelectionMode.single}
                        constrainMode={ConstrainMode.unconstrained}
                        onRenderDetailsHeader={_onRenderDetailsHeader}
                        onColumnHeaderClick={onColumnHeaderClick}
                        onRenderRow={_onRenderRow}
                        getKey={_getKey}
                        enableShimmer={isLoading}
                        // Undefined while loading and changed by every sort, so a load or a sort
                        // resets the row selection as it always has; late client group sections,
                        // which change the rows without either, keep it.
                        setKey={isLoading ? undefined : `locations:${sortRevision}`}
                        layoutMode={DetailsListLayoutMode.justified}
                        isHeaderVisible={true}
                        selectionPreservedOnEmptyClick={true}
                        selection={_selection.current}
                        ariaLabelForSelectionColumn="Toggle selection"
                        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                        checkButtonAriaLabel="Row checkbox"
                    />}
                    {isUploadingFiles && <ShimmeredDetailsList
                        items={[]}
                        columns={columns}
                        enableShimmer={isUploadingFiles}
                    />}
                </ScrollablePane>
            </div>
            {channelErrorDialog}
            {isAdvancedSearchPanelOpen && <CMFAdvancedSearchPanel panelIsOpen={isAdvancedSearchPanelOpen} closePanel={() => setIsAdvancedSearchPanelOpen(false)} />}
            {isPermissionsPanelOpen && <CMPermissionsPanel panelIsOpen={isPermissionsPanelOpen} closePanel={() => setIsPermissionsPanelOpen(false)} sharePointListId={selectedSharepointListId} />}
        </>
    )
};
